import React, { CSSProperties, FC } from 'react';

import { cssVariables, useClassNames } from './StickyTop.styles';
import { StickyTopProps } from './StickyTop.types';

const StickyTop: FC<StickyTopProps> = ({ topOffset = 0, className, children }) => (
  <div
    className={useClassNames(className).root}
    style={{ [cssVariables.topOffset as keyof CSSProperties]: `${topOffset}px` }}
  >
    {children}
  </div>
);

export default StickyTop;
